export default __webpack_public_path__ + "static/zenith-scheda-tecnica-0de25faa5b7ef505ff0c345f60bbfe69.pdf";